import { render, staticRenderFns } from "./SeatTypeLabels.vue?vue&type=template&id=3f2e922d&scoped=true&"
import script from "./SeatTypeLabels.vue?vue&type=script&lang=js&"
export * from "./SeatTypeLabels.vue?vue&type=script&lang=js&"
import style0 from "./SeatTypeLabels.vue?vue&type=style&index=0&id=3f2e922d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e922d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
